type Props = {

}

const InfoBox: React.FC<Props> = ({children}) => {
    return <div className="box-info">
    <div className="content">
        {children}
    </div>
</div>
};

export default InfoBox;
